<template>
  <div>
    <p class="mb-3">
      Consider the three isomers:
      <stemble-latex content="$\ce{NCO-, CNO-,\text{ and }CON-\text{.}}$" />
      One is stable, one is explosive, and the third is unknown. Rank these isomers in terms of
      increasing stability.
      <b>Hint: consider the formal charges.</b>
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question342',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$\\ce{CNO- < CON- < NCO-}$', value: 'a'},
        {text: '$\\ce{CNO- < NCO- < CON-}$', value: 'b'},
        {text: '$\\ce{CON- < CNO- < NCO-}$', value: 'c'},
        {text: '$\\ce{CON- < NCO- < CNO-}$', value: 'd'},
        {text: '$\\ce{NCO- < CON- < CNO-}$', value: 'e'},
      ],
    };
  },
};
</script>
